import React, { useState, useEffect, useCallback } from 'react'
import { useCMSContext } from './../../CMSContext'

import './MarketingSection.scss'
import { useErrorSnackBarContext } from '../../../Shared/ErrorSnackBar/ErrorSnackBarContext'
import { IARDialog } from '../../../Shared/Dialog/IARDialog'
import { parseDate } from '../../../../../resources/Utils'
import CircularProgress from '@mui/material/CircularProgress'
import { MdEdit, MdControlPointDuplicate, MdVisibility } from 'react-icons/md'
import MarketingSectionActions from 'app/Components/CMS/Content/MarketingSection/MarketingSectionActions'
import MarketingSectionOptions from 'app/Components/Shared/MarketingSectionOptions/MarketingSectionOptions'
import MarketingDialog from 'app/Components/Shared/MarketingDialog/MarketingDialog'
import Interceptor from '../../../../Services/serviceBase.interceptor'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  Container,
  Grid,
  Button,
  Paper,
  Checkbox
} from '@mui/material'
import { Navigate } from 'react-router-dom'
import { CustomSwitch } from '../../../Shared/Switch/switch'

function MarketingSection() {
  const cmsContext = useCMSContext()
  const [rowState, setRowState] = useState({})
  const [postDialog, setPostDialog] = useState({ open: false })
  const { errorSnackBarActions } = useErrorSnackBarContext()
  const [errorLabel, setErrorLabel] = useState('')
  const { socket, iarMember, appConfiguration } = cmsContext.state
  const { setSection } = cmsContext.actions
  const [deleteDialog, setDeleteDialog] = useState({ open: false })
  const [marketingSectionsEntity, setMarketingSections] = useState({ marketingSections: [] })
  const [allSelected, setAllSelected] = useState(false)
  const [createMarketing, setCreateMarketing] = useState(true)
  const [isClone, setIsClone] = useState(false)
  const [nameToClone, setNameToClone] = useState(null)
  const [identifierToClone, setIdentifierToClone] = useState(null)
  const [emergencyProviderCloneName, setEmergencyProviderCloneName] = useState(null)
  const [inEditionMCS, setInEditionMCS] = useState([])
  const [showPublishedContent, setShowPublishedContent] = useState(true)
  const [isEditIconClicked, setIsEditIconClicked] = useState(true)
  const [disableFormFields, setDisableFormFields] = useState(false)

  Interceptor.interceptor(errorSnackBarActions)

  const {
    getMarketingCustomSectionByAll,
    searchMarketingCustomSectionListByIdentifier,
    searchMarketingCustomSectionListByCountry,
    searchMarketingCustomSectionListByCountryAndState,
    searchMarketingCustomSectionListByCountryStateAndCounty,
    getMarketingCustomSectionPreviewByAll,
    searchMarketingCustomSectionPreviewByCountry,
    searchMarketingCustomSectionPreviewByCountryAndState,
    searchMarketingCustomSectionPreviewByCountryStateAndCounty,
    searchMarketingCustomSectionPreviewByIdentifier
  } = MarketingSectionActions

  //state set in MarketingSectionOption selection.
  //this one is filled once all options to be created are set.
  const [nameToCreateOrSearch, setNameToCreateOrSearch] = useState('')
  const [selectedOptions, setSelectedOptions] = useState({
    value: '',
    country: '',
    state: '',
    county: '',
    typeOfSearch: 0
  })

  //state for marketing custom section options
  const [openMarketingCustomOptions, setOpenMarketingCustomOptions] = useState(false)
  const [isCreationForOptions, setIsCreationForOptions] = useState(true)
  const [marketingOptions, setMarketingOptions] = useState({})
  const closeMarketingCustomSectionOptionsDialog = () => {
    setOpenMarketingCustomOptions(false)
  }

  useEffect(() => {
    if (appConfiguration.previewEnabled) {
      if (isEditIconClicked) {
        setDisableFormFields(false)
        return
      }
      setDisableFormFields(true)
    }
  }, [isEditIconClicked])

  const handlerFetchSections = useCallback(async () => {
    setPostDialog({ open: false })

    let response

    if (!showPublishedContent && appConfiguration?.previewEnabled) {
      response = await getMarketingCustomSectionPreviewByAll()
    } else {
      response = await getMarketingCustomSectionByAll()
    }

    if (response.length > 0) {
      setMarketingSections({ marketingSections: response })
    } else {
      setMarketingSections({ marketingSections: [] })
    }
  }, [showPublishedContent, appConfiguration.previewEnabled, getMarketingCustomSectionByAll])

  useEffect(() => {
    async function getAll() {
      if (!marketingSectionsEntity?.marketingSections?.length && !nameToCreateOrSearch) {
        let response
        if (!showPublishedContent && appConfiguration?.previewEnabled) {
          response = await getMarketingCustomSectionPreviewByAll()
        } else {
          response = await getMarketingCustomSectionByAll()
        }

        if (response.length > 0) {
          setMarketingSections({ marketingSections: response })
        }
      }
    }

    getAll()
  }, [getMarketingCustomSectionByAll, marketingSectionsEntity, nameToCreateOrSearch])

  useEffect(() => {
    async function getAll() {
      let response

      if (!showPublishedContent && appConfiguration?.previewEnabled) {
        response = await getMarketingCustomSectionPreviewByAll()
      } else {
        response = await getMarketingCustomSectionByAll()
      }

      setMarketingSections({ marketingSections: response })
    }
    setNameToCreateOrSearch('')
    getAll()
  }, [
    appConfiguration?.previewEnabled,
    getMarketingCustomSectionByAll,
    getMarketingCustomSectionPreviewByAll,
    showPublishedContent
  ])

  useEffect(() => {
    if (errorLabel !== '') {
      errorSnackBarActions.setOpen(true, errorLabel)
      setErrorLabel('')
    }
  }, [errorLabel, errorSnackBarActions])

  const getAllHandler = async () => {
    if (!marketingSectionsEntity?.marketingSections?.length && !nameToCreateOrSearch) {
      let response
      if (appConfiguration?.previewEnabled) {
        response = await getMarketingCustomSectionPreviewByAll()
      } else {
        response = await getMarketingCustomSectionByAll()
      }
      if (response.length > 0) {
        setMarketingSections({ marketingSections: response })
      }
    }
  }

  useEffect(() => {
    if (!socket) return

    socket.on(`marketing_section_inner_MCS_list`, (args) => {
      setInEditionMCS(args.ids)

      if (args.param === 'saved' && args.memberId === iarMember.memberId) {
        getAllHandler()
      }
      if (args.param === 'deleted') {
        getAllHandler()
      }
    })
  }, [socket, getMarketingCustomSectionByAll, marketingSectionsEntity, nameToCreateOrSearch])

  const closeCancelMarketigSectionDialog = () => {
    setRowState({})
    setPostDialog({ open: false })
    setIsClone(false)
  }

  const handleRowClick = (id) => {
    if (inEditionMCS?.some((x) => x === id)) return

    const selectedItems = marketingSectionsEntity.marketingSections?.find((el) => el._id === id)
    const msList = marketingSectionsEntity.marketingSections
    const indexOfSelected = msList?.findIndex((el) => el._id === id)
    selectedItems.isSelected = !selectedItems.isSelected
    msList[indexOfSelected] = selectedItems

    setMarketingSections({
      ...marketingSectionsEntity,
      marketingSections: msList
    })
  }

  const openEditionDialog = (item, evt) => {
    setIsClone(false)
    evt.stopPropagation()
    setRowState(item)
    setPostDialog({ open: true })
    setCreateMarketing(false)
  }

  const deleteRecord = useCallback(async () => {
    const marketingSectionsIds = marketingSectionsEntity.marketingSections
      ?.filter((el) => el.isSelected)
      .map((el) => el._id)
    const response = await MarketingSectionActions.deleteMarketingSections(marketingSectionsIds)

    if (response) {
      const filtered = marketingSectionsEntity.marketingSections?.filter((el) => !el.isSelected)
      setMarketingSections(filtered)
    }
    setDeleteDialog({ open: false })
    setRowState({})
  }, [marketingSectionsEntity])

  const cancelDialog = () => {
    setPostDialog({ open: false })
    setRowState({})
    setNameToCreateOrSearch(null)
    setIsClone(false)
  }
  const cancelDeleteDialog = () => {
    setDeleteDialog({ open: false })
    setRowState({})
    setIsClone(false)
  }

  const openConfirmationDialog = () => {
    setDeleteDialog({ open: true })
  }

  const openNewMSDialog = () => {
    setIsClone(false)
    setRowState({})
    setNameToCreateOrSearch('')
    setSelectedOptions({
      value: '',
      state: '',
      county: '',
      typeOfSearch: 0
    })
    setOpenMarketingCustomOptions(true)
    setIsCreationForOptions(true)
    setCreateMarketing(true)
  }

  const onSelectAllClick = useCallback(() => {
    let msList = marketingSectionsEntity.marketingSections?.map((x) => ({
      ...x,
      isSelected: !inEditionMCS?.some((r) => r === x._id) && !allSelected
    }))

    setMarketingSections({
      ...marketingSectionsEntity,
      marketingSections: msList
    })

    setAllSelected(!allSelected)
  }, [marketingSectionsEntity, allSelected, inEditionMCS])

  const openSearchDialog = (evt) => {
    setIsClone(false)
    setOpenMarketingCustomOptions(true)
    setIsCreationForOptions(false)
  }

  useEffect(() => {
    async function CreateOrSearch() {
      if (nameToCreateOrSearch) {
        //if has a name then a creation or a search must be done
        if (isCreationForOptions || isClone) {
          //set the open dialog here
          setPostDialog({ open: true })
        } else {
          let optionSelected = parseInt(selectedOptions.typeOfSearch)
          let response = []
          switch (parseInt(optionSelected)) {
            case 0: // by All
              if (!showPublishedContent && appConfiguration?.previewEnabled)
                response = await getMarketingCustomSectionPreviewByAll()
              else response = await getMarketingCustomSectionByAll()
              break
            case 1: // by country
              if (!showPublishedContent && appConfiguration?.previewEnabled)
                response = await searchMarketingCustomSectionPreviewByCountry(selectedOptions.value)
              else response = await searchMarketingCustomSectionListByCountry(selectedOptions.value)
              break
            case 2: // by country and state
              if (!showPublishedContent && appConfiguration?.previewEnabled)
                response = await searchMarketingCustomSectionPreviewByCountryAndState(
                  selectedOptions.value,
                  selectedOptions.state
                )
              else
                response = await searchMarketingCustomSectionListByCountryAndState(
                  selectedOptions.value,
                  selectedOptions.state
                )
              break
            case 3: // by country, state and county
              if (!showPublishedContent && appConfiguration?.previewEnabled)
                response = await searchMarketingCustomSectionPreviewByCountryStateAndCounty(
                  selectedOptions.value,
                  selectedOptions.state,
                  selectedOptions.county
                )
              else
                response = await searchMarketingCustomSectionListByCountryStateAndCounty(
                  selectedOptions.value,
                  selectedOptions.state,
                  selectedOptions.county
                )
              break
            case 4: // by emergency provider
              if (!showPublishedContent && appConfiguration?.previewEnabled)
                response = await searchMarketingCustomSectionPreviewByIdentifier(
                  selectedOptions.value
                )
              else
                response = await searchMarketingCustomSectionListByIdentifier(selectedOptions.value)
              break
            default:
              break
          }
          if (!response?.length) {
            setErrorLabel('There is no Marketing sections with your search selection.')
          }

          setMarketingSections({ marketingSections: response })
        }
      }
    }
    CreateOrSearch()
  }, [
    getMarketingCustomSectionByAll,
    isCreationForOptions,
    nameToCreateOrSearch,
    searchMarketingCustomSectionListByIdentifier,
    setErrorLabel
  ])

  const openCloneDialog = (row, evt) => {
    evt.stopPropagation()
    setRowState({})
    setOpenMarketingCustomOptions(true)
    const cloneName =
      row.emergencyProviderName || row.emergencyProviderName === ''
        ? row.emergencyProviderName
        : row.name
    setIdentifierToClone(row.name)
    setNameToClone(cloneName)
    setIsClone(true)
  }

  if (iarMember?.isImpersonating) {
    setSection('department-info')
    return <Navigate to="/" replace />
  }

  const switchContent = () => {
    setShowPublishedContent((prev) => !prev)
  }

  const handleChangeIconClicked = (isEdit) => {
    setIsEditIconClicked(isEdit)
  }

  const updateListAfterPublishPreview = async () => {
    const response = await getMarketingCustomSectionPreviewByAll()
    if (response.length > 0) {
      setMarketingSections({ marketingSections: response })
    }
  }

  return (
    <div className="App marketing-sections">
      {(rowState && rowState._id) || (postDialog.open && !rowState._id) ? (
        <MarketingDialog
          id={rowState._id}
          rowName={rowState.name}
          name={nameToCreateOrSearch}
          isOpen={postDialog.open}
          onCancel={closeCancelMarketigSectionDialog}
          onClose={cancelDialog}
          isCreateMarketingSection={createMarketing}
          marketingOptions={marketingOptions}
          setMarketingSections={setMarketingSections}
          isClone={isClone}
          nameToClone={nameToClone}
          identifierToClone={identifierToClone}
          emergencyProviderCloneName={emergencyProviderCloneName}
          fetchSections={handlerFetchSections}
          disableField={disableFormFields}
          showPublished={showPublishedContent}
          updateListAfterPublishPreview={updateListAfterPublishPreview}
        />
      ) : (
        <></>
      )}
      <IARDialog
        open={deleteDialog.open}
        title="Confirm"
        content={
          <div className="dialogContent">
            <div>Do you want to delete selected records?</div>
            <ul>
              {marketingSectionsEntity?.marketingSections
                ?.filter((el) => el.isSelected)
                .map((el) => (
                  <li key={el._id}>{el.emergencyProviderName || el.name}</li>
                ))}
            </ul>
          </div>
        }
        onOk={deleteRecord}
        onCancel={cancelDeleteDialog}
        onClose={cancelDialog}
      />
      <div className="page-header">Menu Section - Marketing Custom Section</div>
      <Container maxWidth="lg">
        {openMarketingCustomOptions ? ( //this is for open the dialog to select the option to create or search
          (<MarketingSectionOptions
            open={openMarketingCustomOptions}
            isCreation={isCreationForOptions}
            onClose={closeMarketingCustomSectionOptionsDialog}
            setNameToCreate={setNameToCreateOrSearch}
            setMarketingOptions={setMarketingOptions}
            setSelectedOptions={setSelectedOptions}
            isClone={isClone}
            nameToClone={nameToClone}
            setEmergencyProviderCloneName={setEmergencyProviderCloneName}
            isPreview={showPublishedContent}
          ></MarketingSectionOptions>)
        ) : (
          <></>
        )}

        <Grid container spacing={2}>
          <Grid size={12}>
            <div className="page-description">
              This is where IaR administrators can created, edit, delete and search optional
              Marketing Custom Sections pages. You can create Marketing sections for All Emergency
              providers, for a specific country, a specific state or a county, you can even select
              the emergency provider and create a Marketing section for it. The Marketing sections
              are going to be visible only for emergency providers with MyLS enabled and Marketing
              Section Enabled, so this permissions must be assigned first to the emergency provider.{' '}
            </div>
          </Grid>
          {appConfiguration?.previewEnabled && (
            <>
              <Grid size={12}>
                {appConfiguration.previewEnabled && !showPublishedContent && (
                  <div class="cannot-edit-label" style={{ marginLeft: '30px' }}>
                    The list you see below contains MARKETING SECTIONS in its PREVIEW MODE and an
                    option to review their PUBLISHED CONTENT. You can add, edit, or delete only
                    MARKETING SECTIONS in its PREVIEW MODE.
                  </div>
                )}
                {appConfiguration.previewEnabled && showPublishedContent && (
                  <div class="cannot-edit-label" style={{ marginLeft: '30px' }}>
                    The list you see below contains only PUBLISHED MARKETING SECTIONS and every
                    community member using MyLS app can visualize it as is. To edit one of them, you
                    need to set "Display Content as PREVIEW MODE" to Yes and start making changes.
                  </div>
                )}
              </Grid>
              <Grid size={6} className="container-field">
                <span>Display Content as PREVIEW MODE</span>
                <CustomSwitch
                  name="showPublished"
                  value={!showPublishedContent}
                  sectionActiveChange={switchContent}
                  useYesNoButtons={true}
                />
              </Grid>
            </>
          )}
          <Grid size={12}>
            <div className="controls-container">
              <Button
                style={{ maxWidth: '250px', minWidth: '250px', left: 0 }}
                variant="contained"
                id="searchMarketingSections"
                color="primary"
                size="medium"
                className="action-buttons"
                onClick={openSearchDialog}
              >
                Search Custom Sections
              </Button>
              <div className="write-button">
                {marketingSectionsEntity.marketingSections?.findIndex((el) => el.isSelected) >
                -1 ? (
                  <Button
                    variant="contained"
                    id="deleteMarketingSectionButton"
                    size="medium"
                    className="deleteMarketingSectionButton"
                    onClick={openConfirmationDialog}
                  >
                    Delete Custom Section
                  </Button>
                ) : (
                  <></>
                )}
                <Button
                  style={{ maxWidth: '250px', minWidth: '250px', right: 0 }}
                  variant="contained"
                  id="addMarketingSectionButton"
                  color="primary"
                  size="medium"
                  className="action-buttons"
                  onClick={openNewMSDialog}
                  disabled={appConfiguration.previewEnabled && showPublishedContent}
                >
                  Add Custom Section
                </Button>
              </div>
            </div>
          </Grid>
          <Grid size={12} className="table-container">
            <TableContainer component={Paper}>
              <Table size="small">
                <TableHead>
                  <TableRow className="table-header">
                    <TableCell>
                      <Checkbox
                        onChange={onSelectAllClick}
                        inputProps={{ 'aria-label': '' }}
                        checked={allSelected}
                      />
                      Marketing Custom Sections
                    </TableCell>
                    <TableCell align="right">Date Published</TableCell>
                    <TableCell align="right"></TableCell>
                    <TableCell align="right"></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody className="marketing-table-body">
                  {marketingSectionsEntity?.marketingSections?.map((row) => (
                    <TableRow
                      key={row._id}
                      hover
                      selected={row.isSelected}
                      onClick={() => handleRowClick(row._id)}
                    >
                      <TableCell component="th" scope="row" className="marketing-section-name">
                        {row.emergencyProviderName || row.emergencyProviderName === ''
                          ? row.emergencyProviderName
                          : row.name}
                      </TableCell>
                      <TableCell align="right" className="marketing-section-date">
                        {parseDate(row.localDate, 'HH:mm MMM dd, y')}
                      </TableCell>
                      <CmsGridIcon
                        previewEnabled={appConfiguration.previewEnabled}
                        isPreview={!showPublishedContent}
                        hasPublished={row.published}
                        isEditing={inEditionMCS?.includes(row._id)}
                        onClick={(evt) => openCloneDialog(row, evt)}
                        onClickEdit={(evt) => openEditionDialog(row, evt)}
                        handleChangeIconClicked={handleChangeIconClicked}
                      />
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
}

function CmsGridIcon({
  isEditing,
  isPreview,
  previewEnabled,
  onClick,
  onClickEdit,
  hasPublished,
  handleChangeIconClicked
}) {
  const handleOnClick = useCallback((e) => onClick?.(e), [onClick])
  const handleOnClickEdit = useCallback((e) => onClickEdit?.(e), [onClickEdit])

  if (previewEnabled) {
    if (isPreview) {
      if (isEditing) {
        return (
          <>
            <TableCell align="center"></TableCell>
            <TableCell align="right">
              <CircularProgress className="grid-icon" size={20} />
            </TableCell>
          </>
        )
      } else {
        if (hasPublished) {
          return (
            <>
              <TableCell align="right">
                <MdControlPointDuplicate
                  className="grid-icon"
                  onClick={(e) => {
                    handleOnClick(e)
                    handleChangeIconClicked(true)
                  }}
                />
              </TableCell>
              <TableCell align="right">
                <MdEdit
                  className="grid-icon"
                  onClick={(e) => {
                    handleChangeIconClicked(true)
                    handleOnClickEdit(e)
                  }}
                />
                <MdVisibility
                  className="grid-icon"
                  onClick={(e) => {
                    handleChangeIconClicked(false)
                    handleOnClickEdit(e)
                  }}
                />
              </TableCell>
            </>
          )
        }

        return (
          <>
            <TableCell align="right">
              <MdControlPointDuplicate
                className="grid-icon"
                onClick={(e) => {
                  handleOnClick(e)
                  handleChangeIconClicked(true)
                }}
              />
            </TableCell>
            <TableCell align="right">
              <MdEdit
                className="grid-icon"
                onClick={(e) => {
                  handleChangeIconClicked(true)
                  handleOnClickEdit(e)
                }}
              />
              <MdVisibility className="marketing-grid-icon-disabled" disabled />
            </TableCell>
          </>
        )
      }
    } else {
      return (
        <>
          <TableCell align="right">
            <MdVisibility
              className="grid-icon"
              onClick={(e) => {
                handleChangeIconClicked(false)
                handleOnClickEdit(e)
              }}
            />
          </TableCell>
          <TableCell align="center"></TableCell>
        </>
      )
    }
  } else {
    if (isEditing)
      return (
        <>
          <TableCell align="center"></TableCell>
          <TableCell align="right">
            <CircularProgress className="grid-icon" size={20} />
          </TableCell>
        </>
      )
    else
      return (
        <>
          <TableCell align="right">
            <MdControlPointDuplicate className="grid-icon" onClick={handleOnClick} />
          </TableCell>
          <TableCell align="right">
            <MdEdit className="grid-icon" onClick={handleOnClickEdit} />
          </TableCell>
        </>
      )
  }
}

export default MarketingSection
